import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slice/userSlice';

const Store = configureStore({
    reducer: {
        userData : userSlice
    }
});

export default Store;
